export namespace S25LocalStorage {
    //https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
    function supportsType(type: "localStorage" | "sessionStorage") {
        let storage: Storage;

        try {
            storage = window[type];
        } catch (e) {
            return false;
        }

        const x: string = "__storage_test__";

        try {
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return (
                e instanceof DOMException &&
                // everything except Firefox
                (e.code === 22 ||
                    // Firefox
                    e.code === 1014 ||
                    // test name field too, because code might not be present
                    // everything except Firefox
                    e.name === "QuotaExceededError" ||
                    // Firefox
                    e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
                // acknowledge QuotaExceededError only if there's something already stored
                storage &&
                storage.length !== 0
            );
        }
    }

    export function get(key: string) {
        if (supportsType("localStorage")) {
            return window.localStorage.getItem(key);
        }
    }

    export function set(key: string, str: string) {
        if (supportsType("localStorage")) {
            return window.localStorage.setItem(key, str);
        }
    }

    export function remove(key: string) {
        if (supportsType("localStorage")) {
            return window.localStorage.removeItem(key);
        }
    }

    export function clear() {
        if (supportsType("localStorage")) {
            window.localStorage.clear();
        }
        if (supportsType("sessionStorage")) {
            window.sessionStorage.clear();
        }
    }
}
